/**
 * Split pre×post scatter points into respondents who grew (y > x) and the
 * rest (stayed equal or declined). The scatter colours the two groups
 * differently. Pure function — no Firebase imports.
 *
 * @param {Array<{respondent: string, x: number, y: number}>} points - Output of buildPrePostScatter
 * @returns {{grown: Array<object>, other: Array<object>}}
 */
const partitionPrePostPoints = (points) => {
    const list = Array.isArray(points) ? points : []
    return {
        grown: list.filter((p) => p.y > p.x),
        other: list.filter((p) => p.y <= p.x),
    }
}

export default partitionPrePostPoints
